"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawStateService = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var page_state_1 = require("../state/page.state");
var index_1 = require("./index");
var log_service_1 = require("./log.service");
var DrawStateService = /** @class */ (function () {
    function DrawStateService(log) {
        this.log = log;
        this.__priority = 100;
        this._drawCacheKeys = [];
        this._drawCacheMap = {};
    }
    DrawStateService.prototype.getIkeDraw = function (collection, captureId) {
        if (page_state_1.CurrentState.CollectionEdit.collectionRevision === collection.revision) {
            return page_state_1.CurrentState.CollectionEdit.getIkeDraw(captureId);
        }
        var drawKey = "".concat(collection.revision, ":").concat(captureId);
        var existing = this._drawCacheMap[drawKey];
        if (existing) {
            return existing;
        }
        var drawState = this.createIkeDraw(collection, captureId);
        this._drawCacheKeys.push(drawKey);
        this._drawCacheMap[drawKey] = drawState;
        // This draw caching limit is arbitrary, It will limit the number of captures
        // that can be rendered at one time in the report..
        if (this._drawCacheKeys.length > 1024) {
            var oldDraws = this._drawCacheKeys.splice(0, 10);
            for (var _i = 0, oldDraws_1 = oldDraws; _i < oldDraws_1.length; _i++) {
                var oldKey = oldDraws_1[_i];
                delete this._drawCacheMap[oldKey];
            }
        }
        return drawState;
    };
    DrawStateService.prototype.createIkeDraw = function (collection, captureId) {
        var capture = collection.state.getCapture(captureId);
        if (capture == null) {
            index_1.Services.Log.Logger.error({ collectionId: collection.id, captureId: captureId }, 'Missing capture');
            return null;
        }
        var window = index_1.Services.Window.window;
        return new core_shared_1.IkeDraw({
            log: this.log,
            collection: collection,
            capture: capture,
            window: window,
            captureMaskFetcher: maskFetcher,
            onStartHOASession: function () {
                index_1.Services.Analytics.trackTiming(core_api_1.TimingEventType.HOA, core_api_1.TimingEventAction.ENTER, collection.id, new Date());
            }
        });
    };
    return DrawStateService;
}());
exports.DrawStateService = DrawStateService;
var maskFetcher = function (collectionId, captureId) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var preSignedMask, response;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, index_1.Services.Department.rest.Capture.getMask({ collectionId: collectionId, captureId: captureId })];
            case 1:
                preSignedMask = _a.sent();
                if (preSignedMask == null) {
                    log_service_1.Logger.error({ collectionId: collectionId, captureId: captureId }, 'Mask presigned URL was empty');
                    return [2 /*return*/, ''];
                }
                return [4 /*yield*/, fetch(preSignedMask.presignedUrl, { headers: { Accept: 'image/svg+xml' } })];
            case 2:
                response = _a.sent();
                if (!response.ok) {
                    log_service_1.Logger.error({ response: response, url: preSignedMask.presignedUrl }, 'Presigned URL returned bad response');
                    return [2 /*return*/, ''];
                }
                log_service_1.Logger.debug({ collectionId: collectionId, captureId: captureId, url: preSignedMask.presignedUrl }, 'Masks fetched');
                return [4 /*yield*/, response.text()];
            case 3: return [2 /*return*/, _a.sent()];
        }
    });
}); };
//# sourceMappingURL=draw.state.service.js.map